import { ProgressBar, Typography } from '@cannect/new-components/atoms'
import { TStepName } from '@cannect/pages/DigitalJourney/types'
import { calculateGroupedProgress, getGroupedSteps, shouldShowProgressBar } from './utils'
import { useDigitalJourney } from '@cannect/hooks/useDigitalJourney'

interface ProgressProps {
  currentStep: TStepName
  orderData?: any
}

export const Progress = ({ currentStep, orderData }: ProgressProps) => {
  const { formData } = useDigitalJourney()
  const groupedSteps = getGroupedSteps(orderData?.order?.deliveryByAssociation)
  const currentStepTitle = groupedSteps.find(({ steps }) => steps.includes(currentStep))?.title || ''
  const canShowProgressBar = shouldShowProgressBar(currentStep, formData?.common_fields?.status, groupedSteps)

  if (!canShowProgressBar) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      <Typography.Text type="captionOne" className="text-neutral-300">
        {currentStepTitle}
      </Typography.Text>

      <div className="flex w-full gap-1">
        {groupedSteps.map(({ key, steps }) => (
          <ProgressBar
            value={calculateGroupedProgress(steps, currentStep, groupedSteps)}
            className="h-[6px] bg-secondary-200"
            key={key}
            indicatorClassName="bg-primary-700"
          />
        ))}
      </div>
    </div>
  )
}
